var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 col-lg-8 col-sm-6",staticStyle:{"max-width":"100%","height":"105vh","padding":"0px"}},[_c('Form-Welcome')],1),_c('div',{staticClass:"col-md-5 col-lg-4 p-5 col-xs-12 col-sm-6",staticStyle:{"background-color":"#35424a"}},[_c('FormLogin')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }